import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IAppReduxState } from '../../models';
import { updateTokenExp, updateCurrentTime } from '../../reducers/core-reducer';
import { UtilService } from '../../services';

function AppHidden() {
  const dispatch = useDispatch();
  const authToken = useSelector<IAppReduxState, string>((x) => x.core.token);

  useEffect(() => {
    let issueTime = 0;
    let expiryTime = 0;

    if (authToken) {
      const payload = JSON.parse(window.atob(authToken.split('.')[1]));
      const tokenExpiresAt = payload.exp;

      issueTime = UtilService.dateToUtc(new Date());
      expiryTime = UtilService.dateToUtc(new Date(tokenExpiresAt * 1000));
    }

    dispatch(updateCurrentTime(issueTime));
    dispatch(updateTokenExp(expiryTime));
  }, [authToken, dispatch]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}

export { AppHidden };
